module.exports = __webpack_public_path__ + "static/media/top-img_4d_mob@2x.49f85c2b.png";